import * as axiosRoot from "axios";
import { Notification, toaster } from "rsuite";
import config from "../globals";
import { callStatusResponse, triggerErrorHandlers } from "./errorHandler";
import { io } from "./io";
import iziToast from "izitoast";

var axiosNoTimeout = axiosRoot.default.create({
  baseURL: config.url,
  timeout: 0,
  headers: { "x-requested-with": "XMLHttpRequest" },
});

const defaultCacheTime = 60000;

window.onunload = function () {
  sessionStorage.clear();
};

axiosNoTimeout.interceptors.request.use(
  function (val) {
    if (io.connected) {
      val.headers.socket = io.id;
    }

    if (val.url?.includes("/fields") || val.params?.cache === true) {
      var url = val.url + (val.params?.cache === true ? "-cached" : "");
      var exists = sessionStorage.getItem(url);
      if (exists) {
        const { data, time } = JSON.parse(exists);
        const currentTime = new Date().getTime();
        if (time === undefined || currentTime > time + defaultCacheTime) {
        } else {
          throw { message: "Fields cached by user.", data, status: 200 };
        }
      }
    }
    if (val.url?.includes("auth") || val.url?.includes("password")) {
      return val;
    } else {
      var token = localStorage.getItem("token");
      if (token) {
        val.headers.authorization = "bearer " + token;

        return val;
      } else {
        throw new axiosRoot.default.Cancel("Operation canceled by the user.");
      }
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosNoTimeout.interceptors.response.use(
  (res) => {
    if (res.status === 200) {
      if (
        res.config?.url &&
        (res.config?.url.includes("/fields") ||
          res.config.params?.cache === true)
      ) {
        var url =
          res.config.url + (res.config.params?.cache === true ? "-cached" : "");

        sessionStorage.setItem(
          url,
          JSON.stringify({ data: res.data, time: new Date().getTime() })
        );
      }
    }
    return res;
  },
  (err) => {
    if (err.message === "Operation canceled by the user.") {
      return err;
    }
    if (err.message === "Fields cached by user.") {
      return err;
    }
    if (
      err.response?.data?.message?.includes(
        "Não foi possivel encontrar o crud de"
      )
    ) {
      callStatusResponse("404");
      return err;
    }
    if (err?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("rolesUser");
      localStorage.removeItem("modules");
      window.location.replace("/login?isAuthDone=true");

      return err;
    }
    if (err?.response?.status === 429) {
      iziToast.error({
        title: "[429] Erro",
        message: "Limite de requisições alcançado!",
        position: "topRight",
        close: true,
      });

    }

    if (err?.response?.status === 403) {
    }

    if (err?.response?.status === 404) {
    }
    if (err?.response?.status === 500) {
      triggerErrorHandlers(err.response);
    }
    return Promise.reject(err);
  }
);

export default axiosNoTimeout;
